import type { ReactNode } from 'react';

import { Accordion, Box, Heading, Paragraph, Tag } from '@zillow/constellation-10';
import { useLeasingUrlParams } from '../../hooks/useLeasingUrlParams';

type Props = {
  children?: ReactNode;
  description?: ReactNode;
  headerText: string;
  isComplete?: boolean;
};

export default function SummarySection({ children, description, headerText, isComplete }: Props): JSX.Element {
  const { propertyId } = useLeasingUrlParams();
  const isLandlord = !!propertyId;

  return (
    <Accordion.Item value={String(headerText)}>
      <Accordion.Header>
        <Box css={{ display: 'flex', flexDirection: 'column' }}>
          <Heading
            level={3}
            css={{
              textStyle:
                'responsive.body-lg-bold' /* eslint-disable-line c11nLint/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
            }}
          >
            {headerText}
          </Heading>
          <Paragraph>{description}</Paragraph>
        </Box>
        {isLandlord &&
          (isComplete ? (
            <Tag tone="success" css={{ textTransform: 'capitalize' }}>
              Complete
            </Tag>
          ) : (
            <Tag tone="warning" css={{ textTransform: 'capitalize' }}>
              Incomplete
            </Tag>
          ))}
      </Accordion.Header>
      <Accordion.Panel>{children}</Accordion.Panel>
    </Accordion.Item>
  );
}
